"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RandomGenerator = (function () {
    function RandomGenerator() {
    }
    RandomGenerator.prototype.getRandString = function () {
        return Math.random().toString(36).substring(2, 6) + Math.random().toString(36).substring(2, 6);
    };
    return RandomGenerator;
}());
exports.RandomGenerator = RandomGenerator;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/RandomGenerator.ts
// module id = 346
// module chunks = 0